import moment from 'moment';

import { computed } from '@angular/core';

import { ApmDateUtils } from '@mitsubishi/utils';

import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

import { PriceListSubfamilyDetails } from '../models/subfamily-price-data.model';

type PriceListDetailsState = {
  isLoading: boolean;
  isEditing: boolean;
  selectedSubfamilyId: number | undefined;
  selectedOrganizationId: number | undefined;
  details: PriceListSubfamilyDetails | undefined;
  selectedPriceListValidityDate: moment.Moment;
};

const initialState: PriceListDetailsState = {
  isLoading: false,
  isEditing: false,
  selectedSubfamilyId: undefined,
  selectedOrganizationId: undefined,
  details: undefined,
  selectedPriceListValidityDate: moment(),
};

export const PriceListDetailsStore = signalStore(
  withState(initialState),
  withMethods(store => ({
    setLoading(loading: boolean) {
      patchState(store, { isLoading: loading });
    },
    setEditing(editing: boolean) {
      patchState(store, { isEditing: editing });
    },
    setSelectedSubfamilyId(id: number | undefined) {
      patchState(store, { selectedSubfamilyId: id });
    },
    setSelectedOrganizationId(id: number | undefined) {
      patchState(store, { selectedOrganizationId: id });
    },
    setDetails(data: PriceListSubfamilyDetails | undefined) {
      patchState(store, { details: data });
    },
    updateValidityDate(date: moment.Moment) {
      patchState(store, { selectedPriceListValidityDate: date });
    },
  })),
  withComputed(({ selectedPriceListValidityDate }) => ({
    isSelectedPriceListValidityDatePastOrPresent: computed(() =>
      ApmDateUtils.isPastOrPresent(selectedPriceListValidityDate())
    ),
  }))
);
